var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0}," .st0{fill:#474545;} "),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M197.8,0C122.1,0,60.5,61.6,60.5,137.3c0,72.9,124.6,243.2,129.9,250.4l5,6.7c0.6,0.8,1.5,1.3,2.5,1.3 c1,0,1.9-0.5,2.5-1.3l4.9-6.7c5.3-7.2,129.9-177.5,129.9-250.4C335.2,61.6,273.6,0,197.8,0z M197.8,88.1 c27.1,0,49.2,22.1,49.2,49.2c0,27.1-22.1,49.2-49.2,49.2c-27.1,0-49.2-22.1-49.2-49.2C148.7,110.2,170.7,88.1,197.8,88.1z"}))]);
}

Location.defaultProps = {"id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 395.7 395.7","style":{"enableBackground":"new 0 0 395.7 395.7"},"xmlSpace":"preserve"};

module.exports = Location;

Location.default = Location;
